import React, { useState, useContext, useEffect } from "react";
import uuid from "react-native-uuid";
import ReactDOM from "react-dom";
import AddCommand from "../../Commands/AddCommand/AddCommand";
import CloseCommand from "../../Commands/CloseCommand/CloseCommand";
import SaveCommand from "../../Commands/SaveCommand/SaveCommand";
import DiscardCommand from "../../Commands/DiscardCommand/DiscardCommand";
import { store } from "../../../store.js";
import useValidationInput from "../../../Hooks/useValidationInput.js";
import useSetProcessOrganigram from "../../../Hooks/useSetProcessOrganigram.js";
import useAxiosOperation from "../../../Hooks/useAxiosOperation.js";
import Workflow from "../Workflow/Workflow";
import Organigram from "../Organigram/Organigram";
import SpinnerIcon from "../../Commands/SpinnerIcon/SpinnerIcon.js";
import EditableDropDownList from "../../EditableDropDownList/EditableDropDownList";
import MiddleEditCommand from "../../Commands/MiddleEditCommand/MiddleEditCommand";
import ShowCommand from "../../Commands/ShowCommand/ShowCommand";
import HideCommand from "../../Commands/HideCommand/HideCommand";
import DropDownListNew from "../../DropDownList/DropDownListNew";
import FormSettings from "../FormSettings/FormSettings";
import SimpleDialog from "../../SimpleDialog/SimpleDialog";
import CheckBox from "../../Commands/CheckBox/CheckBox";
import CustomAlert from "../../SimpleModal/CustomAlert";
import CustomLoading from "../../SimpleModal/CustomLoading";

export default function Information (props)  {
  var _ = require("lodash")
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const axiosOperation = useAxiosOperation(true);
  const setProcessOrganigram = useSetProcessOrganigram();
  const endCode = 999
  const actions = { 
     event : {
      type: {onLoad:"onLoad", onkeyPress:"onkeyPress", onChange:"onChange", onMouseOver: "onMouseOver", onMouseLeave:"onMouseLeave", onBlur: "onBlur", onMouseDown: "onMouseDown", onClick: "onClick", onMouseEnter: "onMouseEnter"},
      lists:[{id:1, item:"onLoad"},{id:2, item:"onChange"},{id:3, item:"onClick"},{id:4, item:"onMouseOver"},{id:5, item:"onMouseLeave"},{id:6, item:"onBlur"},{id:8, item:"onMouseEnter"}]
    },
    replacesValues: {field:"$field", title:"$title"},
    option : {organigram: "Organigram", process: "Process", home: "Home"},
    organigram : {profil:"Profil", chart:"Chart", type: {key:"key", value:"value", destination:"destination"}},
    process : {step:"Step", decision:"Decision", workFlow: "WorkFlow", type: {key:"key", value:"value", destination:"destination"}}
  }

  const currentSetting = {
          options : ["Organigram", "Process", "Home"],
          organigram:{ options : ["Profil", "Chart"]},
          process:{ options : ["Step", "Decision", "WorkFlow"]},
          replacesValues : [{old: "$title", new: ""},{old: "$field", new: ""}]
      }
  

  const menu = {
    operation : {Add:"ADD", Update:"UPDATE", Delete:"DELETE", Select:"SELECT", Settings:"SETTINGS"},
    firstOperand :{ 
      validations : { onBlur: [{ type:"REQUIRE"}]},
      replacesValues : [{old: "$title", new: "firstOperand"},{old: "$field", new: "firstOperand"}] },
    secondOperand :{ 
      validations : { onBlur: [{ type:"REQUIRE"}]},
      replacesValues : [{old: "$title", new: "secondOperand"},{old: "$field", new: "secondOperand"}] },
    key :{ 
      validations : { onBlur: [{ type:"REQUIRE"}]},
      replacesValues : [{old: "$title", new: "wording"},{old: "$field", new: "wording"}] },
    value :{ 
      validations : { },
      replacesValues : [{old: "$title", new: "value"},{old: "$field", new: "value"}] },
    field :{ 
      validations : { onBlur: [{ type:"REQUIRE"}]},
      replacesValues : [{old: "$title", new: "field"},{old: "$field", new: "field"}] },
         
    
    form :{}
  }

  const log = [{type:"SETTINGS", value: "Settings $title", style: {fontFamily:"sans-serif",fontSize:"18px",fontWeight:"bold", color : "Black"}}
  ,{type:"ADD", value: "Add $title", style: {fontFamily:"sans-serif",fontWeight:"normal", color : "Black"}}
  ,{type:"SELECT", value: "Select $title", style: {fontFamily:"sans-serif",fontWeight:"normal", color : "Black"}}
  ,{type:"UPDATE", value: "Update $title", style: {fontFamily:"sans-serif",fontWeight:"normal",color : "Black"} }
  ,{type:"DELETE", value: "Commit deleting", style: {fontFamily:"sans-serif",fontWeight:"normal", color : "rgb(206, 17, 38)"} }
  ,{type:"REQUIRE", value: "The $field is required", style: {fontFamily:"sans-serif", fontWeight:"normal",color : "rgb(206, 17, 38)"} }]
  
const templateOrganigram = { option:actions.organigram.profil , Profil : {details:[]}}
const templateProcess = { option:actions.process.step , Step : {details:[]}}
const [settings, setSetting] = useState({  
  errors:[],
  loading:false,
  showDiscard:false,
  showLeave:false,
  option : actions.option.organigram,
  organigram : templateOrganigram,
  process : templateProcess,
  previousState : {option : actions.option.organigram, organigram : { option:actions.organigram.profil , Profil : {details:[]}}, process : { option:actions.process.step , Step : {details:[]}}},
  
});

const [customAlert, setCustomAlert] = useState({isVisible:false});

//organigram : { option:actions.organigram.profil , Profil : {details:[]}},
//process : { option:actions.process.step , Step : {details:[]}},

  var optionSample = {organigram: {id:0, item:"", value:"", option:actions.organigram.profil , Profil : {details:[]} }
                      ,process: {id:0, item:"", value:"", option:actions.process.step , Step : {details:[]} }}
  
  var optionItem = {id:1, option:"",  key:{id:"", value:"", isClick:false}, value:{id:"", value:"", isClick:false} }
  var optionStep = {id:endCode, globalId:"4fae2036-8ee7-4d0a-9e10-33f6d6d591df", option:"",  key:{id:"ProcessStepkey" + endCode, value:"End", isClick:false}, value:{id:"ProcessStepvalue" + endCode, value:"", isClick:false} }
  
  const isInputValid = useValidationInput();
   
  //const setDataVariableInText = useSetDataVariableInText();

  const getCurrentOption = (current = settings)  => 
  {
    const option = current.option.toLocaleLowerCase()
    return current[option].values ? current[option].values.filter(item => item.id == current[option].id)[0] 
    : {}
  };

  const getProcessToCompare = (actualSettings) => {
    const process = getCurrentOption(actualSettings)
    return {item:process.item, value:process.value, code:process.code, Decision:process.Decision, Step:process.Step, WorkFlow:process.WorkFlow && process.WorkFlow.data}
  };
  
  const getOrganigramToCompare = (actualSettings) => {
    
    const organigram = getCurrentOption(actualSettings)
   
    return {item:organigram.item, value:organigram.value , Profil:organigram.Profil, Chart:organigram.Chart && organigram.Chart.data}
  };
  
  const isEqual =() => {
    
    switch (settings.option) {   
  
      case actions.option.organigram: {
        return _.isEqual(getOrganigramToCompare(settings), getOrganigramToCompare(settings.previousState))
      }
  
      case actions.option.process: {
        
        return _.isEqual(getProcessToCompare(settings), getProcessToCompare(settings.previousState))
      }

      case actions.option.home: {
        
        return settings.home && _.isEqual(settings.home.metaData, globalState.state.formData.metaData)
      }
        
    }
  
    return false
   };

   const isDiagramSet =() => {
    
    switch (settings.option) {   
  
      case actions.option.organigram: {
        
        return getCurrentOption(settings).Chart != undefined
      }
  
      case actions.option.process: {
        
        return getCurrentOption(settings).WorkFlow != undefined
      }
      case actions.option.home: {
        
        return true
      }
        
    }
  
    return false
   };
  
  
  const isChanged = isDiagramSet() && !isEqual()
  
  const setHome = () => {
  
    var formData = JSON.parse(JSON.stringify(globalState.state.formData));
    delete formData.log
    delete formData.menu
    delete formData.lists.validations
    axiosOperation({method:"POST"
        , url: "https://flex-services.onrender.com/home/"+ globalState.state.company.id +"/"
        , body:{values:formData}
      }, true).then(response => 
      { 
        if(response.managedError) {
          
          const home = response.result.data
          setSetting({...settings, home:home.values})    
          dispatch({
            type: "INITIALIZE_FORM",
            payload: {formData:home.values},
          });
         
        }
        else {
          //page error
          setSetting({...settings, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
        }
      })
  }


  useEffect(() => {
    //const params = useLocation().search
    
    if ( !settings.loaded ) {
      var settingsData = JSON.parse(JSON.stringify(settings));
      axiosOperation({method:"GET"
        , url: "https://flex-services.onrender.com/settings/"+ globalState.state.company.id +"/"
        }, true).then(response => 
          { 
            if(response.managedError) {
              
              const result = response.result.data
              const resultOrganigram = result.organigram.values.length > 0 ? result.organigram : templateOrganigram
              const resultProcess = result.process.values.length > 0 ? result.process : templateProcess
                             //settingsData = {...settingsData, loaded:true, organigram:{...settingsData.organigram, ...result.organigram}}
              settingsData = {...settingsData, loaded:true, organigram:resultOrganigram, process:resultProcess, home:result.home.values}
                
              //settingsData = {...settingsData, loaded:true,process:{...settingsData.process, ...result.process}}
              //settingsData = {...settingsData, loaded:true,process:resultProcess}
             
              updatePreviousState(settingsData)
              var setStepValue = undefined
              if (globalState.state.step == undefined)
                setStepValue = setProcessOrganigram(settingsData.organigram, settingsData.process, true)
              
              setSetting(settingsData)                
                dispatch({
                  type: result.home.values != null ? "INITIALIZE_FORM" : "REFRESH_FORM",
                  payload: {formData:result.home.values, setStepValue:setStepValue},
                });
              
            }
            else {
              
              setSetting({...settings, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
            }
          })
    }
      
  }, []);
   
  //useEffect(() => {
    //setSetting({...settings})
  //}, [globalState.state.formData.metaData]);

  useEffect(() => {
    //const params = useLocation().search

    if ( actions.option.organigram == settings.option ) {
      var settingsData = JSON.parse(JSON.stringify(settings));
      getCurrentOption(settingsData).Chart = {
        currentMaxId : globalState.state.organigramItems.lists.currentMaxId,
        data : JSON.parse(JSON.stringify(globalState.state.organigramItems.data))
      }
      
      setSetting(settingsData)
    }
      
  }, [JSON.stringify(globalState.state.organigramItems.data)]);

  useEffect(() => {
    
    if ( actions.option.process == settings.option ) {
      
      var settingsData = JSON.parse(JSON.stringify(settings));
      getCurrentOption(settingsData).WorkFlow = {
        currentMaxId : globalState.state.processItems.lists.currentMaxId,
        data : JSON.parse(JSON.stringify(globalState.state.processItems.data))
      }
      setSetting(settingsData)
    }
      
  }, [JSON.stringify(globalState.state.processItems.data)]);

  const isItemInDiagram = (type, data, id) => {
    const n = data.length
    var i = 0
    var found = false
    while(i < n && !found) {
      const node = data[i]
      found = node.items.data.filter(current => current.list == type && current.item.id == id).length > 0
      i = i + 1
      const l = node.childs.length
      var k = 0
      while(k < l && !found) {
        found = node.childs[k].items.data.filter(current => current.list == type && current.item.id == id).length > 0
        k = k + 1
      }     
    };
    return found
  }

  const canDeleteItem = (data, option, id) => {
    
    switch (option) {
      case actions.organigram.profil:
        return !isItemInDiagram ("Steps", data, id)
      case actions.process.step:
        return !isItemInDiagram ("Steps", data, id)
      case actions.process.decision:
        return !isItemInDiagram ("Decisions", data, id)
    }
    
  }

  const setDiagramItem = (type, data, id, newValue) => {
    data.forEach(node => {
      node.items.data.filter(current => current.list == type && current.item.id == id)
        .forEach(nodeData => { nodeData.item.item = newValue})
        if (node.childs.length)
          node.childs.forEach(child => {
            
            child.items.data.filter(current => current.list == type && current.item.id == id)
              .forEach(nodeData => { nodeData.item.item = newValue})   
        })
    });
  }

  const updateDiagramData = (data, option, id, newValue) => {
    
    switch (option) {
      case actions.organigram.profil:
        setDiagramItem("Steps", data, id, newValue)
        //setCharData(data)
        break;
      case actions.process.step:
        setDiagramItem("Steps", data, id, newValue)
        //setWorkFlowData(data)
        break;
      case actions.process.decision:
        setDiagramItem("Decisions", data, id, newValue)  
        //setWorkFlowData(data)
        break;
    }
    
  }

  const changeValue = (value, fieldId ,fieldName="value", detail = undefined) => {
    var settingsData = JSON.parse(JSON.stringify(settings));
    var currentOption = getCurrentOption(settingsData)
    if (detail) {
      currentOption[currentOption.option].details.filter(item => item.id == detail.id)[0][detail.type].value = value;
      //getCurrentOption(settingsData)[getCurrentOption(settingsData).option].details.filter(item => item.id == detail.id)[0][detail.type].value = value;
      if (isProcessActif() && currentOption.WorkFlow) updateDiagramData(currentOption.WorkFlow.data, currentOption.option, detail.id, value)
      if (isOrganigramActif() && currentOption.Chart) updateDiagramData(currentOption.Chart.data, currentOption.option, detail.id, value)
    }
    else {
       
      //getCurrentOption(settingsData)[fieldName] = value;
      //getCurrentOption(settingsData)["fieldId"] = fieldId
      currentOption[fieldName] = value;
      currentOption["fieldId"] = fieldId
     
    }
    setSetting(settingsData)
  };

const replaceValue = (value, replaces) => {
  if( replaces )
    replaces.map(replace => value = value.replace(replace.old, replace.new)) 
  return value
}

const getTitle = () => {
  var replaces = currentSetting.replacesValues
  var currentType =  menu.operation.Settings
  var menuError = " "
   
  if (onError) {
    //const currentOption = isOrganigramActif() ? getCurrentOption().option : settings.option
    const currentOption = getCurrentOption().option 
    const currentError = settings.errors.filter(error => error.option == currentOption).slice(-1)[0]
    if (currentError) {
      currentType = currentError.type 
      replaces = currentError.replacesValues
    } else {
      const defaultError = settings.errors.slice(-1)[0]
      currentType = defaultError.type 
      replaces = defaultError.replacesValues
      
      menuError =  isOrganigramSubOption(defaultError.option) ? 
                    (isOrganigramActif() ? " ( " : " ( Organigram --> ") + defaultError.option + " )" :
                   (isProcessSubOption(defaultError.option) ? 
                    (isProcessActif() ? " ( " : " ( Process --> ") + defaultError.option + " )"
                    :  " ( " + defaultError.option + " )")
    } 
    
  } 
  
  return log.filter(
    log => log.type == currentType
  ).map( log =>  {return <span style = {log.style}>{replaceValue(log.value, replaces) + menuError}</span>})[0]
}

const fireEventKeyPressByMenu = (e, detail, event) => {
  const typeEvents = menu[detail.type].validations[event]
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  settingsData.errors = settingsData.errors.filter(error => error.id != detail.id )

  if(!isInputValid({value: e.key}, typeEvents).isValid) {
    e.preventDefault()
  }
  setSetting(settingsData);
}


const fireEventByMenuAndConditionAndSetValue = (e, detail, event) => {
  
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  const typeEvents = menu[detail.type].validations ? menu[detail.type].validations[event] : []
  const eventResponse = isInputValid({value: e.target.value}, typeEvents);
  
  if(eventResponse.isValid) {
    settingsData.errors = settingsData.errors.filter(error => !(error.id == detail.id && error.event == event) )
  }
  else {
    settingsData.errors.push({id:detail.id
      , option: isOrganigramActif() ? getCurrentOption().option : settings.option
      , event:event, type:eventResponse.type, replacesValues: menu[detail.type].replacesValues})
  }
 
  setSetting(settingsData);
}

const getNodeTypes = (nodes, keys, type) => {
  nodes.map(node => {
    keys.push(node[type])
    getNodeTypes(node.childs, keys, type)
  })
}

const deleteProcess = () => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  axiosOperation({method:"DELETE"
      , url: "https://flex-services.onrender.com/process/"+ globalState.state.company.id +"|"+ getCurrentOption().id +"/"
      , body:{id:globalState.state.company.id}
    }, true).then(response => 
    { 
      if(response.managedError) {
        const result = response.result.data
        settingsData = {...settingsData, loading:false, process:result.process.id == null ? templateProcess : result.process}
        settingsData.previousState.process = settingsData.process
        
        setSetting(settingsData)
      }
      else {
        setSetting({...settings, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
      }
    })
}

const deleteOrganigram = () => {

  var settingsData = JSON.parse(JSON.stringify(settings));
  axiosOperation({method:"DELETE"
      , url: "https://flex-services.onrender.com/organigram/"+ globalState.state.company.id +"|"+ getCurrentOption().id +"/"
    }, true).then(response => 
    { 
      if(response.managedError) {
        
        const result = response.result.data
        
        //settingsData = {...settingsData, loaded:true,organigram:{...settingsData.organigram, ...result.organigram}}
        settingsData = {...settingsData, loading:false,organigram:result.organigram.id == null ? templateOrganigram : result.organigram}
        settingsData.previousState.organigram = settingsData.organigram
        
        setSetting(settingsData)
      }
      else {
        //page error
        setSetting({...settings, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
      }
    })
}

const setProcess = () => {
  
  var settingsData = JSON.parse(JSON.stringify(settings));
  axiosOperation({method:"POST"
      , url: "https://flex-services.onrender.com/process/"+ globalState.state.company.id +"/"
      , body:{...settings.process, values :[getCurrentOption()]}
    }, true).then(response => 
    { 
      if(response.managedError) {
        
        const result = response.result.data
        
        //settingsData = {...settingsData, loaded:true,process:{...settingsData.process, ...result.process}}
        
        settingsData = {...settingsData, loading:false, process:result.process}
        settingsData.previousState.process = settingsData.process
        
        setSetting(settingsData)
      }
      else {
        //page error
        setSetting({...settings, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
      }
    })
}

const setOrganigram = () => {

  var settingsData = JSON.parse(JSON.stringify(settings));
  axiosOperation({method:"POST"
      , url: "https://flex-services.onrender.com/organigram/"+ globalState.state.company.id +"/"
      , body:{...settings.organigram, values :[getCurrentOption()]}
    }, true).then(response => 
    { 
      if(response.managedError) {
        
        const result = response.result.data
        
        //settingsData = {...settingsData, loaded:true,organigram:{...settingsData.organigram, ...result.organigram}}
        settingsData = {...settingsData, loading:false, organigram:result.organigram}
        settingsData.previousState.organigram = settingsData.organigram
        
        setSetting(settingsData)
      }
      else {
        //page error
        setSetting({...settings, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
      }
    })
}

const fireEventOnSaveValue = (event = "onBlur") => {
  
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  setSetting({...settingsData, loading:true})
  var typeEvents = [] //currentSetting[event]
  
  switch (settingsData.option) {   

    case actions.option.organigram: {
      let detailsToValidate = []
      const organigramSettings = ["Profil"];
      const settingsToValidate = getCurrentOption(settingsData) 
      organigramSettings.map(option =>
        settingsToValidate[option] && settingsToValidate[option].details 
        && settingsToValidate[option].details.length > 0 && detailsToValidate.push(settingsToValidate[option].details)
      )
           
      detailsToValidate = detailsToValidate.flat(Infinity)
      
      let keyData = detailsToValidate.map(detail =>{return {option:detail.option, key:detail.key }})
      let keyEvents = menu.key.validations[event]
      keyData.map(itemData => {
        let eventResponse = isInputValid({value: itemData.key.value}, keyEvents);
        if(!eventResponse.isValid) 
          settingsData.errors.push({id:itemData.key.id, option: itemData.option, event:event, type:eventResponse.type
            , replacesValues: menu.key.replacesValues})
        }
      )
      let valueData = detailsToValidate.map(detail => {return {option:detail.option, value:detail.value }})
      let valueEvents = menu.value.validations[event]
      valueData.map(itemData => {
        let eventResponse = isInputValid({value: itemData.value.value}, valueEvents);
        if(!eventResponse.isValid) 
          settingsData.errors.push({id:itemData.value.id, option: itemData.option, event:event, type:eventResponse.type
            , replacesValues: menu.value.replacesValues})
        }
      )

      if (settingsData.errors.length == 0) setOrganigram()
  
        
      break;
    }

    case actions.option.process: {
      let detailsToValidate = []
      const processSettings = ["Step", "Decision"];
      const settingsToValidate = getCurrentOption(settingsData) 
      processSettings.map(option =>
        settingsToValidate[option] && settingsToValidate[option].details 
        && settingsToValidate[option].details.length > 0 && detailsToValidate.push(settingsToValidate[option].details)
      )
           
      detailsToValidate = detailsToValidate.flat(Infinity)
      
      let keyData = detailsToValidate.map(detail =>{return {option:detail.option, key:detail.key }})
      let keyEvents = menu.key.validations[event]
      keyData.map(itemData => {
        let eventResponse = isInputValid({value: itemData.key.value}, keyEvents);
        if(!eventResponse.isValid) 
          settingsData.errors.push({id:itemData.key.id, option: itemData.option, event:event, type:eventResponse.type
            , replacesValues: menu.key.replacesValues})
        }
      )
      let valueData = detailsToValidate.map(detail => {return {option:detail.option, value:detail.value }})
      let valueEvents = menu.value.validations[event]
      valueData.map(itemData => {
        let eventResponse = isInputValid({value: itemData.value.value}, valueEvents);
        if(!eventResponse.isValid) 
          settingsData.errors.push({id:itemData.value.id, option: itemData.option, event:event, type:eventResponse.type
            , replacesValues: menu.value.replacesValues})
        }
      )
      
      if (settingsData.errors.length == 0) setProcess()
      break;
    }

    case actions.option.home: {

      
      if (settingsData.errors.length == 0) setHome()
      break;
    }
      
  }
 
  
  if (settingsData.errors.length != 0) setSetting(settingsData);

  
}


const getOptionForm = (value) => {
  
  switch (value) {
    case actions.option.organigram:
    case actions.option.process:
      return getOption()   
    case actions.option.home:
      return <FormSettings />
  }
}



const getOptionDescription = (width = "100%") => {
  const fieldId = settings.option + "DescriptionValue"
  return <div id={settings.option + "DescriptionValue"} style={{  display: "flex", marginRight: "5px"}} >
          <textarea
            className="textBox"
            value={getCurrentOption().value? getCurrentOption().value : ""}
            //onKeyPress={(e) => fireEventKeyPress(e, {id : fieldId},actions.event.type.onkeyPress) }
            //onBlur={(e) => fireOtherEvent(e, {id : fieldId},actions.event.type.onBlur) }
            onChange={(e) => changeValue(e.target.value, fieldId) }
            style={{width: width, height: "53px", marginLeft: "5px"}}/>
          
        </div>
}

const getDetailOptionSettingValue = (id, type, isSubBody = false) => {
  const current = getCurrentOption()
  var currentOptionSetting = current[current.option]
  currentOptionSetting = currentOptionSetting.details.filter(item => item.id == id);
  if (currentOptionSetting) {
    const value = currentOptionSetting[0][type].value
    return value
  }
  else
    return ""
}


const isKeyColonne = (type) => {
  
  return type == actions.organigram.type.key
}

const isValueColonne = (type) => {
  
  return type == actions.organigram.type.value
}

const isClickOnHide = (isHide) => {
  
  return isHide[actions.organigram.type.key].isClick
}

const getCommandIcon = (type, isHide) => {
  return isKeyColonne(type) ? (isHide ? <HideCommand />  : <ShowCommand /> )
          :  <MiddleEditCommand className ="hoverBlue"/>
}

const getTypeInput = (type, item) => {
  return isValueColonne(type) && isClickOnHide(item) ? "password" : "text"
}

const isInError = (id)=> {
   
  return settings.errors.filter(error => error.id == id).length > 0
}

const getInput =(item, type, fieldId, placeHolder, option) => {
  return  <input
    className="textBoxWithoutBorder"
    type = {getTypeInput(type, item)}
    placeholder = {placeHolder}
    maxLength = {option.size}
    readOnly = {isProcessStepActif() && item.id == endCode}
    value={getDetailOptionSettingValue(item.id, type)}
    onKeyPress={(e) => fireEventKeyPressByMenu(e, {id:fieldId, type:type  }, actions.event.type.onkeyPress) }
    onBlur={(e) => fireEventByMenuAndConditionAndSetValue(e, {id:fieldId, type:type  }, actions.event.type.onBlur) }
    onChange={(e) => changeValue(e.target.value, fieldId, "value",{id:item.id, type:type  }) }
    style={{width: option.width, fontSize: "12px",fontFamily: "Arial", paddingTop: "3px"
    , border: isInError(fieldId) ? "1px solid rgb(206, 17, 38)" : undefined}}/>

}

const getTextRelation = (item, type, fieldId, placeHolder, option ={width : "250px"}) => {
  
  return <div id ={fieldId} style={{  display: "flex", marginRight: "5px"}} >
          {getInput(item, type, fieldId, placeHolder, option)}
         
      </div>
}

const getSeparator = () => {
  return <div style={{  height: "17px", margin:"5px 15px 0px 0px",  borderRight:"2px solid rgb(223, 221, 221)" }} /> 
}

const onSelectOperator = (id, itemSelected) => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  const current = getCurrentOption(settingsData)
  var currentOptionSetting = current[current.option]
  currentOptionSetting.details.filter(item => item.id == id)[0].type = {value : itemSelected.item};
        
  setSetting(settingsData)
}

const getOptionItem = (item)=> {
  const current = getCurrentOption()
  const option = settings.option.toLocaleLowerCase()
  const keyId = item.key.id //settings.option + getCurrentOption().option + actions.organigram.type.key + item.id
  const valueId = item.value.id //settings.option + getCurrentOption().option + actions.organigram.type.value + item.id
  const isProfilActif = current.option == actions.organigram.profil
  const width = isProfilActif ? "221px" : "270px"
  return <div key = {item.id} className ="gridLine">
        {getTextRelation(item, actions[option].type.key, keyId, "Wording", {width : width, size:25 } )}
        {getSeparator()}
        {isProfilActif && <div style={{  minWidth: "80px", maxWidth: "80px"}} >
        <DropDownListNew
          currentData={[{id:1, item:"Private"},{id:2, item:"Public"}]}
          minWidth={"30px"}
          initialValue={item.type.value}
          id={"OperatorList" + item.id}
          onDropDownItemClick={(itemSelected) => onSelectOperator(item.id, itemSelected)}
          onlyLabel={false}
        />
        </div>}
        {isProfilActif && getSeparator()}
        {isProfilActif ? getPolicyItem(item) : getTextRelation(item, actions[option].type.value, valueId, "Comment", {width : width, size:50})}

        { !(isProcessStepActif() && item.id == endCode) && <div
          onClick={(e) => onClickDeleteOptionSetting(e, item.id, [keyId, valueId]) } 
          style ={{ marginLeft: "5px" }}>
          <CloseCommand className ="hoverRed"/>
        </div>}
       
  </div> 
}

const onClickAddOptionSetting = (e) => {
  e.preventDefault();
  const option = settings.option.toLocaleLowerCase()
  var settingsData = JSON.parse(JSON.stringify(settings));
  var currentOption = getCurrentOption(settingsData)
  //var current = getCurrentOption(settingsData)[getCurrentOption().option]
  var current = currentOption[currentOption.option]
  //var keyId = settings.option + getCurrentOption().option + actions[option].type.key 
  //var valueId = settings.option + getCurrentOption().option + actions[option].type.value  
  //optionItem.option = getCurrentOption().option

  var keyId = settings.option + currentOption.option + actions[option].type.key 
  var valueId = settings.option + currentOption.option + actions[option].type.value 
  optionItem.option = currentOption.option
  
  if (optionItem.option == actions.organigram.profil) optionItem.type = {value : "Private"}
  if (current.details.length > 0) {
    //getCurrentOption(settingsData)[getCurrentOption().option].maxDetailsId = getCurrentOption(settingsData)[getCurrentOption().option].maxDetailsId + 1
    //getCurrentOption(settingsData)[getCurrentOption().option].detailsId = getCurrentOption(settingsData)[getCurrentOption().option].maxDetailsId 
    //optionItem.id = getCurrentOption(settingsData)[getCurrentOption().option].detailsId
    if (current.maxDetailsId == endCode) current.maxDetailsId = current.maxDetailsId +1
    current.maxDetailsId = current.maxDetailsId + 1
    current.detailsId = current.maxDetailsId 
    optionItem.id = current.detailsId
    optionItem.globalId = uuid.v4()
    optionItem.key.id = keyId + optionItem.id
    optionItem.value.id = valueId + optionItem.id 
    current.details.push(optionItem)

  }
  else {
    //getCurrentOption(settingsData)[getCurrentOption().option]["detailsId"] = 0
    //getCurrentOption(settingsData)[getCurrentOption().option]["maxDetailsId"] = 0
    current["detailsId"] = 1 //0 begin with 1 because template begin with 0 (New step or New decision)
    optionItem.globalId = uuid.v4()
    current["maxDetailsId"] = 1 //0
    optionItem.key.id = keyId + 1 //+ 0
    optionItem.value.id = valueId + 1 //+ 0
    current.details = [optionItem]
    if (isProcessStepActif()) {
      current.details.push(optionStep)
    }
 }
 
  setSetting(settingsData)
}

const updatePreviousData = (settingsData) => {
 
  if ( isOrganigramActif() ) { //actions.option.organigram == settings.option
    settingsData.organigram = settingsData.previousState.organigram
    const chart = getCurrentOption(settingsData.previousState).Chart 
    setCharData(chart ? chart.data : [])
  }
  if ( isProcessActif() ) { //actions.option.process == settings.option
    settingsData.process = settingsData.previousState.process
    const workFlow = getCurrentOption(settingsData.previousState).WorkFlow
    setWorkFlowData(workFlow ? workFlow.data : [])
  } 

  if ( isHomeActif() ) { //actions.option.process == settings.option
   
    dispatch({
      type: "INITIALIZE_FORM",
      payload: {formData:settingsData.home},
    });
  } 

  settingsData.showDiscard = false
  settingsData.showLeave = false
  settingsData.errors = []
}

const onDiscard = (e) => {
  e.preventDefault();
  var settingsData = JSON.parse(JSON.stringify(settings));
  updatePreviousData(settingsData)
  setSetting(settingsData)
}


const onLeave = (e) => {
  e.preventDefault();
  var settingsData = JSON.parse(JSON.stringify(settings));
  updatePreviousData(settingsData)
  if (settingsData.next) {
    settingsData.option = settingsData.next
    settingsData.previousState.option = settingsData.next
    settingsData.next = undefined
  }
 
  setSetting(settingsData)
}

const onClickDeleteOptionSetting = (e, id, lineIds) => {
  var canDeleteCurrentOption = false 
  e.preventDefault();
  var settingsData = JSON.parse(JSON.stringify(settings));
  var currentOption = getCurrentOption(settingsData)
  if (isProcessActif()) 
    canDeleteCurrentOption = !currentOption.WorkFlow ? true : canDeleteItem(currentOption.WorkFlow.data, currentOption.option, id)
  else if (isOrganigramActif()) 
    canDeleteCurrentOption = !currentOption.Chart ? true : canDeleteItem(currentOption.Chart.data, currentOption.option, id)
  if (canDeleteCurrentOption) {
    
    currentOption[currentOption.option].details = currentOption[currentOption.option].details.filter(condition => condition.id != id)
    settingsData.errors = settingsData.errors.filter(error =>  !lineIds.includes(error.id) )
    setSetting(settingsData)
  } else {
    if (isProcessActif()) 
      setCustomAlert({...alert, isVisible:true, text:"Can't delete this value because it's used in the workFlow."})
      
    else if (isOrganigramActif()) 
      setCustomAlert({...alert, isVisible:true, text:"Can't delete this value because it's used in the chart."})
      
    
  }
}

const setCharData = (data) => {
  var organigramItems = JSON.parse(JSON.stringify(globalState.state.organigramItems))
  organigramItems.data = data
  dispatch({
    type: "SET_ORGANIGRAM_SETTINGS",
    payload: organigramItems,
  });
}

const setWorkFlowData = (data) => {
  var processItems = JSON.parse(JSON.stringify(globalState.state.processItems))
  processItems.data = data
  dispatch({
    type: "SET_PROCESS_SETTINGS",
    payload: processItems,
  });       
}

const onClickValid = (e, detail) => {
  
  const type = settings.option.toLocaleLowerCase()
  if (e) e.preventDefault();
  var itemToUpdate = optionSample[settings.option.toLocaleLowerCase()] 
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  
    switch (detail.operation) {
      case menu.operation.Add:{   
          
        if (settingsData[type].values) {
          
          //settingsData[type].maxId = settingsData[type].maxId + 1
          settingsData[type].id = uuid.v4() //settingsData[type].maxId 
          itemToUpdate.id =  settingsData[type].id
          itemToUpdate.item = detail.value
          
          settingsData[type].values.push(itemToUpdate)
         
        }
        else {
          settingsData[type] = {id : uuid.v4(), maxId :0} //{id : 0, maxId :0}
          //settingsData[type]["maxId"] = 0
          
          itemToUpdate.id = settingsData[type].id
          itemToUpdate.item = detail.value
          settingsData[type].values = [itemToUpdate]
        }
        if ( isOrganigramActif() ) { //actions.option.organigram == settings.option
          setCharData([])
        }
        if ( isProcessActif() ) { //if ( actions.option.process == settings.option ) {
          setWorkFlowData([])
        } 
        setSetting(settingsData)              
        break;
      }
      case menu.operation.Update:{
        settingsData[type].values
        .filter(item => item.id == settingsData[type].id)
        .map(current => current.item = detail.value)
        setSetting(settingsData)
        break;
      }

      case menu.operation.Delete:{
        
        setSetting({...settingsData, loading:true})
        if (isOrganigramActif(settingsData.option)) { //(settingsData.option == actions.option.organigram)
          setCharData([])
          deleteOrganigram()
        }
        if (isProcessActif(settingsData.option)) { //(settingsData.option == actions.option.process) 
          setWorkFlowData([])
          deleteProcess()
        }
        break;
      }
    }
   
  
}

const getOptionList = ()=> {
  const option = settings.option.toLocaleLowerCase()
  return settings[option].values ? 
    settings[option].values.map(valueItem => { return {id : valueItem.id, item:valueItem.item }})
    : []
}

const getSubOption  = (current) => {
  const option = settings.option.toLocaleLowerCase()
  
  switch (current.option) {
    case actions[option].workFlow:
      //actualizeWorkFlow(current)
      return <Workflow settings = {current} organigram= {settings.organigram} process= {settings.process}/>
    case actions[option].chart:
      //actualizeOrganigram(current)
      return <Organigram settings = {current} organigram= {settings.organigram} process= {settings.process}/>
    default:
      return current[current.option].details.map(item => getOptionItem(item))
  }
}

const getOption = () => {
  const current = getCurrentOption()
  const option = settings.option.toLocaleLowerCase()
  
  return (
    <React.Fragment>
      {getOptionConfig(current, "200px")}
      {current.option ? 
      <React.Fragment>
        <div className ="gridInnerLine" >
          <span>
            Description:
          </span>
          <div>
            {getOptionDescription("503px")}
          </div>
        </div>   
     
      <div className ="gridInnerLine" style= {{width: isOrganigramActif() ? "790px" : "595px"}}>
        {currentSetting[option].options.length > 1 && 
          <div className="modal-line">
            {currentSetting[option].options.map((item, index) => getOptionParams(item, index))}
          </div>}
     
        { (current.option != actions.organigram.chart 
          && current.option != actions.process.workFlow) && <div  
          onClick={(e) => onClickAddOptionSetting(e) } 
          style ={{ marginLeft: "auto", paddingRight:"3px", marginTop:"5px" }}>
          <AddCommand className ="hoverGreen"/>
        </div>}
      </div>   
      <div >
        { current[current.option] && getSubOption(current)}
      </div>
      </React.Fragment>:null}

  </React.Fragment>)
}

const getNode = (nodes, parentId) => {

  let node = nodes.map(child => {
    if (child.id == parentId)
      return child
    else
      return getNode(child.childs, parentId)
  })
  
  return node.flat(Infinity)
}


const getOptionConfig = (current, width = "100%") => {
  const fieldId = settings.option + "ConfigValue"
  const currentConfigOption = getCurrentOption()
  return <div id={settings.option + "ConfigValue"} style={{  display: "flex", marginBottom: "5px"}} >
            <div style ={{ width: "245px" }}>
              <EditableDropDownList
                id="OptionList"
                title="Name:"
                initialValue={current ? current.item: ""}
                currentData={getOptionList()}
                policy={{
                  canAdd : !isChanged, 
                  canEdit : currentConfigOption.option != undefined, 
                  canDelete : currentConfigOption.option != undefined }}
                type = {"field"}
                onDropDownItemClick={(itemSelected) => onSelect(itemSelected)}
                width = "200px"
                style = {{ }}
                onClickValid={(e, detail) => onClickValid(e, detail)}/>
            </div>
            { isProcessActif() &&
            <React.Fragment>
              <span style ={{ userSelect: "none", fontWeight:"bold",marginLeft: "10px", marginTop: "2px",marginRight: "10px",fontSize:"14px" , fontFamily:"sans-serif"  }}>Code: </span>
              <input
                maxLength={4}
                className="textBoxWithoutBorder"
                value={currentConfigOption.code != undefined ? currentConfigOption.code : "PROC" }
                onKeyPress={(e) => !isNaN(e.key) && e.preventDefault() }
                onChange={(e) => saveConfig("code", e.target.value) }
                style={{width: "45px", fontSize: "14px", marginRight:"5px", marginTop: "-2px"}}/>
              
              </React.Fragment>
            }
        </div>
}

const changePolicy = (value, policyType, detail ) => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  var currentOption = getCurrentOption(settingsData)
  
  currentOption[currentOption.option].details.filter(item => item.id == detail.id)[0][detail.type][policyType] = value;
   
 
  setSetting(settingsData)
};

const getPolicyItem = (item)=> {
    
  
  const option = settings.option.toLocaleLowerCase()
    
  return <div style={{  display: "flex", width: "420px"}} >
        <span style={{  userSelect: "none"}} >request:</span>
        <CheckBox checked={item.value.request} click={() => changePolicy(!item.value.request, "request",{id:item.id, type:actions[option].type.value  })}/>
        <span style={{  userSelect: "none"}}>board:</span>
        <CheckBox checked={item.value.board} click={() => changePolicy(!item.value.board, "board",{id:item.id, type:actions[option].type.value  })}/>
        <span style={{  userSelect: "none"}} >consultation:</span>
        <CheckBox checked={item.value.consultation} click={() => changePolicy(!item.value.consultation, "consultation",{id:item.id, type:actions[option].type.value  })}/>
        <span style={{  userSelect: "none"}} >settings:</span>
        <CheckBox checked={item.value.settings} click={() => changePolicy(!item.value.settings, "settings",{id:item.id, type:actions[option].type.value  })}/>
        <span style={{  userSelect: "none"}} >admin:</span>
        <CheckBox checked={item.value.admin} click={() => changePolicy(!item.value.admin, "admin",{id:item.id, type:actions[option].type.value  })}/>

        </div>
}

const updatePreviousState = (settingsData) => {
  settingsData.previousState =  JSON.parse(JSON.stringify(settingsData))
}

const onChangeOption = (optionText) => {
  if (isChanged) 
    setSetting({...settings, showLeave: true, next:optionText})
  else {
    var settingsData = JSON.parse(JSON.stringify(settings));
    settingsData = {...settings, option: optionText, next:undefined}
    updatePreviousState(settingsData)
    setSetting(settingsData)
  }
}

const getOptionPanel = (optionText, index) => {
  return <div id = {"Type" + optionText} key={"Type" +index} className="modal-list" onClick={() => onChangeOption(optionText)} >
          <div style={{marginRight: "20px", userSelect:"none",  borderBottom: optionText == settings.option ? "2px Solid dodgerblue" : "none"}}>
            {optionText}
          </div> 
        </div>
}

/*
const getOptionRadio = (optionText, index, isMultipleChoice) => {
  return <div key={index} className="modal-list">
          {isMultipleChoice && <div style={{ paddingTop: "2px"}}>
            <RadioIcon checked={isChecked(optionText)}
            click={() => onChangeOption(optionText)} />
          </div>}
          <div style={{marginRight: "20px"}}>
            {optionText}
          </div> 
        </div>
}*/

const setCurrentOption = (optionValue) => {
  var settingsData = JSON.parse(JSON.stringify(settings));
  
  switch (optionValue) {
    case actions.process.workFlow:   
    case actions.organigram.chart:   
      if (!getCurrentOption(settingsData)[optionValue]) getCurrentOption(settingsData)[optionValue] = {data:[]}
      break;
    default:
      if (!getCurrentOption(settingsData)[optionValue]) getCurrentOption(settingsData)[optionValue] = {details:[]}
      
      break;
     
  }
  getCurrentOption(settingsData).option =optionValue
  
  setSetting(settingsData)

}


const setBodyMethod = (optionValue) => {
  
  var settingsData = JSON.parse(JSON.stringify(settings));
  getCurrentOption(settingsData)[actions.organigram.body].option =optionValue
  setSetting(settingsData)
}

const getOptionParams = (optionText, index) => {
  return <div id = {"Organigram" +optionText} key={"Organigram" +index} className="modal-list" onClick={() => setCurrentOption(optionText)} >
          <div style={{marginRight: "20px", userSelect:"none",  borderBottom: optionText == getCurrentOption().option ? "2px Solid dodgerblue" : "none"}}>
            {optionText}
          </div> 
        </div>
}

const isOrganigramSubOption  = (optionTocheck) => {
  return optionTocheck == actions.organigram.profil 
      || optionTocheck == actions.organigram.chart
    
}

const isProcessSubOption  = (optionTocheck) => {
  return optionTocheck == actions.process.step 
      || optionTocheck == actions.process.decision
      || optionTocheck == actions.process.workFlow
}

const isOrganigramActif  = (optionTocheck = settings.option) => {
  return optionTocheck == actions.option.organigram 
}

const isProcessActif  = (optionTocheck = settings.option) => {
  return optionTocheck == actions.option.process 
}

const isHomeActif  = (optionTocheck = settings.option) => {
  return optionTocheck == actions.option.home 
}

const isProcessStepActif  = () => {
  return isProcessActif() && getCurrentOption().option == actions.process.step
}


const onError = settings.errors.length > 0

const onSelect = (itemSelected) => {
  if (isChanged) 
    setSetting({...settings, showLeave: true, next:undefined})
  else {
    var settingsData = JSON.parse(JSON.stringify(settings));
    settingsData[settings.option.toLocaleLowerCase()].id = itemSelected.id
    if ( actions.option.organigram == settings.option ) {
      const chart = getCurrentOption(settingsData).Chart 
      setCharData(chart ? chart.data : [])
    }
    if ( actions.option.process == settings.option ) {
      const workFlow = getCurrentOption(settingsData).WorkFlow 
      setWorkFlowData(workFlow ? workFlow.data : [])
    }
    updatePreviousState(settingsData)
    setSetting(settingsData)
  }
}


const actualizeWorkFlow = (current) => {
  if (current.Step && current.Decision) {
    var processItems = JSON.parse(JSON.stringify(globalState.state.processItems)) 
    processItems.lists.Steps = current.Step.details.map(detail => {return {id : detail.id, item:detail.key.value }} )
    processItems.lists.Decisions = current.Decision.details.map(detail => {return {id : detail.id, item:detail.key.value }} )
    const step = processItems.lists.Steps[0]
    
    if (step) {
      var template = {
        id: 1,
        order: 1,
        isExpanded: true,
        isChecked: true,
        policy: { read: true, edit: true, delete: true },
        menu: "menuSteps",
        items: {
        width: { 1: "100%" },
        data: [
          {
            id: 1,
            item: { id: step.id, item: step.item },
            order: 1,
            isChecked: true,
            list: "Steps",
          },
        ],
      },
      childs: [],
      }
      if (current.WorkFlow.data.length > 0) {
        const workFlow = JSON.parse(JSON.stringify(current.WorkFlow))
        processItems.lists.currentMaxId = workFlow.currentMaxId
        processItems.data = workFlow.data
      }
      else {
        processItems.lists.currentMaxId = 1
        processItems.data = [template]
      }
      
      
    } else {
      processItems.lists.currentMaxId = 1
      processItems.data = []
    }
    dispatch({
      type: "SET_PROCESS_SETTINGS",
      payload: processItems,
    });
  } 
}

const actualizeOrganigram = (current) => {
  var organigramItems = JSON.parse(JSON.stringify(globalState.state.organigramItems)) 
      organigramItems.lists.Steps = current.Profil.details.map(detail => {return {id : detail.id, item:detail.key.value }} )
      organigramItems.lists.Decisions = []
      const step = organigramItems.lists.Steps[0]
      
      if (step) {
        var template = {
          id: 1,
          order: 1,
          isExpanded: true,
          isChecked: true,
          policy: { read: true, edit: true, delete: true },
          menu: "menuSteps",
          items: {
          width: { 1: "100%" },
          data: [
            {
              id: 1,
              item: { id: step.id, item: step.item },
              order: 1,
              isChecked: true,
              list: "Steps",
            },
          ],
        },
        childs: [],
        }
        if (current.Chart.data.length > 0) {
          const chart = JSON.parse(JSON.stringify(current.Chart))
          organigramItems.lists.currentMaxId = chart.currentMaxId
          organigramItems.data = chart.data
        }
        else {
          organigramItems.lists.currentMaxId = 1
          organigramItems.data = [template]
        }
        
        
      } else {
        organigramItems.lists.currentMaxId = 1
        organigramItems.data = []
      }
      
      
      dispatch({
        type: "SET_ORGANIGRAM_SETTINGS",
        payload: organigramItems,
      });
}

const saveConfig = (type, itemSelected) => {
 
  var settingsData = JSON.parse(JSON.stringify(settings));
  var currentOption = getCurrentOption(settingsData)
  if (currentOption) {
    currentOption[type] = itemSelected
    setSetting(settingsData)
  }

}

return <React.Fragment>
          
            <div style ={{ padding:"10px 0 10px 20px", marginTop:"30px", backgroundColor: "white"}}>
              <div >    
               
                {getTitle() }
                        
               
              </div>  
              <div>
                {<div className="modal-line">
                  {currentSetting.options.map((item, index) => getOptionPanel(item, index))}
                  {getSeparator()}
                  <div onClick ={() => !onError && fireEventOnSaveValue()} style={{paddingTop: "6px", userSelect:"none", marginRight:"5px", width:"20px"}}>
                    { settings.loading ? 
                      <div style ={{ marginTop:"-2px"}}><SpinnerIcon /> </div>: 
                      <SaveCommand actif = { isChanged} height="15px" /> }
                  </div> 
                  <div style={{paddingTop: "2px", userSelect:"none", marginRight:"10px"
                  , color : isChanged ? "black" : "rgb(223, 221, 221)" }}>
                    <span>Save</span> 
                  </div>
                  <div id = "InformationDiscardCommand" onClick ={(e) => setSetting({...settings, showDiscard:true})} style={{paddingTop: "6px", userSelect:"none", marginRight:"5px", width:"20px"}}>
                    { <DiscardCommand actif = { isChanged} height="15px" /> }
                  </div> 
                  <div style={{paddingTop: "2px", userSelect:"none", marginRight:"10px"
                  , color : isChanged ? "black" : "rgb(223, 221, 221)" }}>
                    <span>Discard</span> 
                  </div>
                </div>}
                {getOptionForm(settings.option)}
              </div>
              
              
            </div>
            {settings.showDiscard && <SimpleDialog changeModeRequired ={false} 
              onClickValid ={(e) => onDiscard(e)} onClose = {() => setSetting({...settings, showDiscard:false})}  
              value = "Are you sure ?"
              isLabel = {true}
              parentId = "InformationDiscardCommand" type = "field" operation = "DISCARD"/>}
            {settings.showLeave && <SimpleDialog changeModeRequired ={false} onClickValid ={(e) => onLeave(e)} 
              onClose = {() => setSetting({...settings, showLeave:false})}  
              value = "Do you want to leave ?"
              isLabel = {true}
              parentId = "InformationDiscardCommand" type = "field" operation = "LEAVE"/>}
            {customAlert.isVisible && <CustomAlert width={"300px"} title={"Settings"} 
              text = {customAlert.text} hide = {() => setCustomAlert({...customAlert, isVisible:false})}/>}
            {!settings.loaded && <CustomLoading />}
        </React.Fragment>
  }

/*
  <div className="modal-line-left">
                <div onClick={props.hide} >
                  <input style ={{ border: "1px solid lightGray", backgroundColor: "white", fontSize:"12px", color : "lightGray"
                  , height: "25px", padding: "0px", width: "100px", }} type="button" className="button" value="Cancel"/>
                </div>
                <div onClick ={() => !onError && fireEventOnSaveValue()}>
                  <input style ={{ backgroundColor: onError  ? "lightGray" : "#008dff",  fontSize:"12px"
                  , height: "25px", padding: "0px", width: "100px", }} 
                  type="button" className="button" value="Save"/>
                </div>
              </div>
*/

